import { setLocaleObjectNamespace } from "../../../common/src/setLocaleObjectNamespace";

export default setLocaleObjectNamespace("program", {
    'view.types': 'Display type (layout)',
    'view.tiles': 'Tiles',
    'view.lines': 'Lines',
    'view.tabs': 'Tabbed',
    'view.page': 'List on the page',
    'view.hide': 'Do not display',
    'days.view': 'Days display type',
    'halls.view': 'Halls view type',
    'members.photo.show': 'Show photos of members in the grid',
    'calendar.buttons.show': 'Show Add to Calendar buttons',
    'watchRecording.button.show': 'Показывать кнопку Смотреть запись',
    'settings.view': 'Settings for displaying', 
    'settings.tiles': 'Settings for displaying tiles',
    'settings.lines': 'List display settings',
    'settings.timelines': 'Time display intervals settings',
    'time.minutes': '{minutes} minutes',
    'time.without.interval': 'Without intervals',
    'description.show': 'Expand descriptions of all reports by default',
    'modals.show': 'Show modals in schedule',
});
